module.exports = __webpack_public_path__ + "img/idcard_zhengmian.0db15a33.png";